export default __webpack_public_path__ + "static/media/coin_flip_decision_5.9e614b5a.png";